<template>
  <div
    class="neutral--text d-flex align-center"
    :class="conditionalClasses"
  >
    <font-awesome-icon
      :icon="icon"
      class="mx-2 mr-3"
      :class="iconTone"
      :size="iconSize"
    />
    <div
      class="text-body-m"
      :class="{ 'neutral--text text--tone-400' : $vuetify.breakpoint.mdAndUp }"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    iconTone: {
      type: String,
      default: 'neutral--text text--tone-400',
    },
    iconSize: {
      type: String,
      default: 'xl',
    },
    filled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    conditionalClasses() {
      return {
        'neutral tone-100': this.filled,
        // eslint-disable-next-line quote-props
        'white': !this.filled,
        'outlined pl-2': this.outlined,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .outlined {
    border: 1px solid var(--v-neutral-tone-200) !important;
    border-radius: 8px;
    height: 56px;
  }
</style>
